import jwt_decode from "jwt-decode";
import { KeyboardEvent } from "react";
import storage from "helpers/local-storage";

import api from "helpers/api";
import Res from "types/response";

export interface Inputs {
    [key: string]: string;
}
export enum InputType {
    Email = "email",
    Mobile = "phone",
}

export const inputsKey: string = "verify";
export const verifyTime: number = 2 * 60 * 1000;
export const emailPattern: RegExp = /^.+@.+\..+$/;
export const phonePattern: RegExp = /^(?:00|\+)[0-9]{6,20}$/;
export const passwordPattern: RegExp =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
// /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/

const limitedChars = [
    // Backspace, Tab, Enter, LeftArrow, RightArrow, Delete, Plus
    8, 9, 13, 37, 39, 46, 107, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97,
    98, 99, 100, 101, 102, 103, 104, 105,
];
export function limitChars(e: KeyboardEvent<HTMLInputElement>): void {
    if (!limitedChars.includes(e.keyCode)) e.preventDefault();
}

export const getType = (input: string): InputType =>
    phonePattern.test(input) ? InputType.Mobile : InputType.Email;

export enum Next {
    Register = "/auth/register/profile",
    Recover = "/auth/recover/password",
    Profile = "/profile",
}
export const sendotp: { [key in Next]: string } = {
    [Next.Register]: "v1/auth/send-register-otp",
    [Next.Recover]: "v1/auth/send-reset-password-otp",
    [Next.Profile]: "v1/users/send-update-login-otp",
};
export const verify: { [key in Next]: string } = {
    [Next.Register]: "v1/auth/verify-register-otp",
    [Next.Recover]: "v1/auth/verify-reset-password-otp",
    [Next.Profile]: "v1/users/verify-update-login-otp",
};

export async function sendOTP(
    input: string,
    next: Next,
    ref?: any
): Promise<{ input: string; next: Next; token: string }> {
    if (getRemain(input) > 0) return { next, input, token: getTemp(input) };
    const { data }: Res<{ temp_token: string }> = await api.set(
        sendotp[next],
        "post",
        { body: { [getType(input)]: input }, ref }
    );
    const inputs: Inputs = storage.get(inputsKey) || {};
    inputs[input] = data.temp_token; // Date.now();
    storage.set(inputsKey, inputs);
    return { next, input, token: data.temp_token };
}

export function getTemp(input: string): string {
    const inputs: Inputs = storage.get(inputsKey) || {};
    return inputs[input];
}

export function getRemain(input: string): number {
    const token = getTemp(input);
    if (!token) return -1;
    const decoded = jwt_decode<{ exp: number }>(token);
    return Math.max(decoded.exp * 1000 - Date.now(), 0);
    // return Math.max(verifyTime - (Date.now() - inputs[input]), 0);
}

export function formatAsTime(remain: number): string {
    const t = Math.round(remain / 1000);
    const m = ("0" + Math.floor(t / 60)).slice(-2);
    const s = ("0" + Math.floor(t % 60)).slice(-2);
    return [m, s].join(":");
}
